import _slicedToArray from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/slicedToArray"; //@ts-check

import React from 'react';
import Form from '../../../../form/field';
import fieldLogic from '../logic/fieldsLogic';
import useInputRef from './useInputRef';
import Description from '../controls/Description';
/**
 *
 * @param {import('../components/types').FormFieldTextBoxProps} params
 */

var FormFieldText = function FormFieldText(_ref) {
  var caption = _ref.caption,
      active = _ref.active,
      value = _ref.value,
      fieldId = _ref.fieldId,
      dispatch = _ref.dispatch,
      required = _ref.required,
      error = _ref.error,
      readonly = _ref.readonly,
      description = _ref.description;

  var _useInputRef = useInputRef(active),
      _useInputRef2 = _slicedToArray(_useInputRef, 1),
      inputRef = _useInputRef2[0];

  var onChange = function onChange(event) {
    if (!event) return;
    fieldLogic.onChange(fieldId, event.target.checked, dispatch);
  };

  var onFocus = function onFocus() {
    return fieldLogic.onFocus(fieldId, dispatch);
  };

  var onBlur = function onBlur() {
    return fieldLogic.onBlur(fieldId, dispatch);
  };

  var hasError = !!error;
  var helperText = error || '';
  return React.createElement(React.Fragment, null, React.createElement(Form.Input.Checkbox, {
    style: {
      paddingLeft: 20
    },
    ref: inputRef,
    error: hasError,
    disabled: readonly,
    helperText: helperText,
    checked: !!value,
    label: caption,
    required: required,
    onChange: onChange,
    onBlur: onBlur,
    onFocus: onFocus
  }), React.createElement(Description, {
    error: error,
    description: description
  }));
};

export default React.memo(FormFieldText);